<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col cols="12" sm="12" md="10">
        <v-row class="pt-4">
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="title"
              clear-icon="mdi-close"
              label="Tiêu đề"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="isPublished"
              :items="[
                { title: 'Xuất bản', value: true },
                { title: 'Chưa xuất bản', value: false }
              ]"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="T.Thái hiển thị"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="isOpenRegistration"
              :items="[
                { title: 'Đang mở', value: true },
                { title: 'Đã đóng', value: false }
              ]"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="T.Thái đăng ký"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="isExpired"
              :items="[
                { title: 'Vẫn còn hạn', value: false },
                { title: 'Đã quá hạn', value: true }
              ]"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="T.Thái hết hạn"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="appliedType"
              :items="APPLIED_TYPE_SELECT_ITEMS"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Đối tượng áp dụng"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" sm="12" md="2">
        <v-btn class="search-button" :class="{ 'px-2': windowWidth < 1100 }" @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'
import helpers from './helpers'

export default {
  data: () => ({
    title: '',
    isPublished: null,
    isOpenRegistration: null,
    isExpired: null,
    appliedType: null,
    windowWidth: window.innerWidth,
    APPLIED_TYPE_SELECT_ITEMS: helpers.APPLIED_TYPE_SELECT_ITEMS,
  }),
  methods: {
    onFilterChanged() {
      const params = { title_contains: textHelpers.removeSpaces(utils.clearUnicode(this.name)) }
      if (typeof this.isPublished === 'boolean') params['isPublished'] = this.isPublished
      if (typeof this.isOpenRegistration === 'boolean') params['isOpenRegistration'] = this.isOpenRegistration
      this.$emit('onFilterChanged', params)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>
